import {
  StateCreator, UseBoundStore, StoreApi, create,
} from 'zustand';
import { immer } from 'zustand/middleware/immer';

type TaskStatus = 'pending' | 'success';
type TaskType = 'splitImage' | 'mergeImage' | 'superImage' | 'cutOutImage' | 'modifyImage' | 'eraserImage' | 'extendImage' | 'modifyTextImage' | 'screenshotImage' | 'fusionImage' | 'audioDenoise';

interface TaskItem {
  taskId: string;
  layerId: string;
  roomId: string;
  status: TaskStatus;
  type: TaskType;
  customData: Record<string, any>;
  callback: (...p: any[]) => void;
}

interface LayerTaskState {
  taskQuery: TaskItem[];
  checkLayerInTask: (layerIds: string[]) => boolean;
}

const layerTaskSlice: StateCreator<LayerTaskState, [
  ['zustand/immer', never],
]> = (_, get) => ({
  taskQuery: [],
  checkLayerInTask(layerIds: string []) {
    return get().taskQuery.some((item) => {
      const curLayerIds = layerIds.join(',');
      return item.layerId.split(',').some((id) => curLayerIds.includes(id));
    });
  },
});

const useLayerTaskStore: UseBoundStore<StoreApi<LayerTaskState>> = create<LayerTaskState>()(immer(layerTaskSlice));
export default useLayerTaskStore;

/**
 * 添加任务
 *
 * @export
 * @param {TaskItem} item
 */
export function addTask(item: Omit<TaskItem, 'status'>) {
  useLayerTaskStore.setState((state) => ({
    taskQuery: [...state.taskQuery, { ...item, status: 'pending' }],
  }));
}

/**
 * 删除任务
 *
 * @export
 * @param {string} taskId
 */
export function deleteTask(taskId: string) {
  useLayerTaskStore.setState((state) => ({
    taskQuery: state.taskQuery.filter((item) => item.taskId !== taskId),
  }));
}

/**
 * 查找任务
 *
 * @export
 * @param {string} layerId
 * @return {*}
 */
export function findTask(taskId: string) {
  return useLayerTaskStore.getState().taskQuery.find((item) => item.taskId === taskId);
}

/**
 * 判断任务队列中是否有当前元素的任务
 *
 * @export
 * @param {string} layerId
 * @return {*}
 */
export function hasTaskByLayerId(layerIds: string[]) {
  return useLayerTaskStore.getState().taskQuery.some((item) => {
    const curLayerIds = layerIds.join(',');
    return item.layerId.split(',').some((id) => curLayerIds.includes(id));
  });
}
